var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.912,46.567l6.829-6.829c0.658-0.658,1.734-0.658,2.392,0L43.48,50.085V7.991c0-0.93,0.761-1.692,1.692-1.692h9.657  c0.93,0,1.692,0.761,1.692,1.692v42.094l10.347-10.347c0.658-0.658,1.734-0.658,2.392,0l6.829,6.829  c0.658,0.658,0.658,1.734,0,2.392L51.283,73.765c-0.351,0.351-0.821,0.509-1.283,0.485c-0.462,0.024-0.932-0.134-1.283-0.485  L23.912,48.96C23.254,48.302,23.254,47.225,23.912,46.567z M94.288,92.206V53.148c0,0,0.003-0.528-0.459-0.961  c-0.358-0.336-0.867-0.336-0.867-0.336h-8.989c0,0-0.38,0.001-0.786,0.367c-0.42,0.379-0.42,0.866-0.42,0.866V82.18H17.233V53.148  c0,0,0.003-0.528-0.459-0.961c-0.358-0.336-0.867-0.336-0.867-0.336H6.919c0,0-0.38,0.001-0.786,0.367  c-0.42,0.379-0.42,0.866-0.42,0.866v39.148c0,0.807,0.661,1.468,1.468,1.468h85.613C93.615,93.701,94.288,93.028,94.288,92.206z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e8ad0d3f8c20b54c3b912e368a4c856e.svg";
export { ForwardRef as ReactComponent };